module.exports = __webpack_public_path__ + "img/scene4-1.8ebbc548.png";